

export class Translator{
    private static _translate: (val:string) => string;

    public static translate(val:string):string {
        return this._translate(val);
    }

    constructor(func:(val:string) => string){
        Translator._translate = func;
    }
}
